(function(){
  if (window.__mpnStk) return; window.__mpnStk = true;
  (function(){ var l = document.querySelector('#ProductGridContainer link[href*="/mpn-sticky-cats.css"]'), c = l && l.closest('#ProductGridContainer');
    if (c && !document.querySelector('link[data-mpn-keep="mpn-sticky-cats"]')) { var k = l.cloneNode(); k.setAttribute('data-mpn-keep', 'mpn-sticky-cats'); c.parentNode.insertBefore(k, c); } })();
  var bar, tiles, built = false, ticking = false, on = false, restore = null, wasOpen = false;
  var ICON = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M2 5h9M15 5h3M2 15h3M9 15h9" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="13" cy="5" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/><circle cx="7" cy="15" r="2" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  function summary(){ return document.querySelector('.facets-container-drawer summary.mobile-facets__open-wrapper') || document.querySelector('summary.mobile-facets__open-wrapper'); }

  function build(){
    bar = document.querySelector('[data-mpn-stk]');
    if (!bar) return false;
    tiles = document.querySelector('.mpn-subcols:not(.mpn-subcols--bottom)');
    var row = document.createElement('div');
    row.className = 'mpn-stk__row page-width';
    var sm = summary();
    if (sm) {
      var lab = sm.querySelector('.mobile-facets__open-label');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mpn-stk__filter';
      b.innerHTML = ICON;
      b.setAttribute('aria-label', lab ? lab.textContent.trim() : 'Filtres');
      b.addEventListener('click', function(){
        var s = summary(); if (!s) return;
        // Le tiroir de filtres remet le focus sur son bouton (en haut de page) a la fermeture,
        // ce qui faisait remonter la page : on empeche ce defilement et on revient ou etait le visiteur.
        s.focus = function(){ HTMLElement.prototype.focus.call(this, { preventScroll: true }); };
        restore = { y: window.scrollY, q: location.search };
        s.click();
      });
      row.appendChild(b);
    }
    var track = document.createElement('div');
    track.className = 'mpn-stk__track';
    var l = bar.getAttribute('data-label');
    if (l) { var s = document.createElement('span'); s.className = 'mpn-stk__label'; s.textContent = l; track.appendChild(s); }
    if (tiles) {
      tiles.querySelectorAll('.mpn-subcols__link').forEach(function(a){
        var t = a.querySelector('.mpn-subcols__title');
        var x = document.createElement('a');
        x.className = 'mpn-stk__link' + (a.classList.contains('is-active') ? ' is-active' : '');
        x.href = a.getAttribute('href');
        x.textContent = t ? t.textContent.trim() : a.textContent.trim();
        track.appendChild(x);
      });
      bar.setAttribute('aria-label', tiles.getAttribute('aria-label') || '');
    }
    if (!tiles) bar.classList.add('mpn-stk--solo');
    row.appendChild(track);
    // Ordinateur : Ambiance | Matiere, memes boutons que la barre au-dessus de la grille (geres par snippets/mpn-view-toolbar.liquid)
    var seg0 = document.querySelector('.mpn-view-toolbar .mpn-seg');
    if (seg0) {
      var seg = seg0.cloneNode(true);
      seg.classList.add('mpn-stk__seg');
      row.appendChild(seg);
    }
    bar.appendChild(row);
    bar.hidden = false;
    document.body.appendChild(bar); // hors des sections : position fixe fiable, survit aux filtres
    built = true;
    return true;
  }

  function headerBottom(){
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var b = h.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }

  // Point de declenchement : bas des vignettes, sinon bas de la barre Ambiance/Matiere/Filtres, sinon haut de la grille
  function anchorBottom(){
    if (tiles && document.body.contains(tiles)) return tiles.getBoundingClientRect().bottom;
    var w = document.querySelector('.mpn-view-toolbar');
    if (w) return w.getBoundingClientRect().bottom;
    var g = document.getElementById('product-grid');
    return g ? g.getBoundingClientRect().top : Infinity;
  }

  // Menu du haut survole / ouvert : la barre s'efface, sinon elle passait par-dessus le menu deroulant et le fermait (oct. 2026, demande d'Ed)
  var hdrHover = false;
  function drawerOpen(){
    if (hdrHover || document.querySelector('.section-header details[open], .section-header .mega-menu[open]')) return true;
    if (/overflow-hidden/.test(document.body.className) || document.documentElement.classList.contains('overflow-hidden')) return true;
    /* volet filtres : « ouvert » seulement tant qu'il porte menu-opening (l'attribut open reste parfois un instant apres la fermeture et la barre ne revenait pas, nov. 2026) */
    return !!document.querySelector('.mobile-facets__disclosure.menu-opening, #Details-menu-drawer-container[open]');
  }

  // Fermeture du tiroir ouvert depuis la barre : meme position si rien n'a change, haut de la grille si un filtre a ete applique
  function afterClose(){
    var r = restore; restore = null;
    if (!r) return;
    setTimeout(function(){
      if (location.search !== r.q) {
        var g = document.getElementById('ProductGridContainer');
        if (g) window.scrollTo(0, Math.max(0, g.getBoundingClientRect().top + window.scrollY - headerBottom() - 60));
      } else {
        window.scrollTo(0, r.y);
      }
    }, 60);
  }

  function update(){
    ticking = false;
    if (!built) return;
    var open = drawerOpen();
    if (wasOpen && !open) afterClose();
    wasOpen = open;
    var show = false;
    if (!open) {
      var top = headerBottom();
      var grid = document.getElementById('ProductGridContainer');
      var gridBottom = grid ? grid.getBoundingClientRect().bottom : Infinity;
      show = anchorBottom() < top && gridBottom > top + 120;
      bar.style.top = top + 'px';
    }
    if (show !== on) {
      on = show;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) {
        var act = bar.querySelector('.mpn-stk__link.is-active');
        var tr = bar.querySelector('.mpn-stk__track');
        if (act && tr) tr.scrollLeft = Math.max(0, act.offsetLeft - tr.offsetLeft - 16);
      }
    }
  }
  function req(){ if (!ticking) { ticking = true; requestAnimationFrame(update); } }

  function init(){
    if (!build()) return;
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', req);
    new MutationObserver(req).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('toggle', req, true);
    document.addEventListener('click', function(){ setTimeout(req, 50); setTimeout(req, 600); }, true);
    var hd = document.querySelector('.section-header');
    if (hd) {
      hd.addEventListener('mouseenter', function(){ hdrHover = true; req(); });
      hd.addEventListener('mouseleave', function(){ hdrHover = false; req(); });
    }
    if (hd) new MutationObserver(function(){ req(); setTimeout(req, 320); }).observe(hd, { attributes: true, attributeFilter: ['class'] });
    req();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
